import db from '@/assets/js/localstorage';
export default {
    state: {
        appId: db.get('APPID'),//行业客户
        userName: db.get('USER_NAME'),//登录用户名
        accessToken: db.get('ACCESS_TOKEN'),//token 
        permissions: db.get('PERMISSIONS', []),//用户权限
        authMap: db.get('AUTHMAP', {}),//用户权限map
        userData: db.get('USER_DATA',{}),// h5用户体检报告信息
    },
    getters : {
        userName: state => state.userName,
        permissions: state => state.permissions,
        authMap: state => state.authMap,
        userData: state => state.userData,
    },
    mutations: {
        setAppID(state, val) {
            db.save('APPID', val);
            state.appId = val;
        },
        setUserName(state, val) {
            db.save('USER_NAME', val);
            state.userName = val;
        },
        setAccessToken(state, val) {
            db.save('ACCESS_TOKEN', val);
            state.accessToken = val;
        },
        setPermissions(state, val) {
            db.save('PERMISSIONS', val);
            state.permissions = val;
        },
        setAuthMap(state, val) {
            db.save('AUTHMAP', val);
            state.authMap = val;
        },
        setUserData(state, val) {
            db.save('USER_DATA', val);
            state.userData = val;
        }
    }
};
